<div class="modal-heading modal-heading-1">
	<div class="label_name">{{ 'SELECT_UPLOAD_SOURCE.UPLOAD_SOLUTION' | translate }}</div>
</div>

<div class="modal-body p-0">
	<div class="upload-modal__option" (click)="useWebCam()">
		<div class="upload-modal__option-title">{{ 'SELECT_UPLOAD_SOURCE.USE_WEBCAM' | translate }}</div>
		<div class="upload-modal__option-subtitle">{{ 'SELECT_UPLOAD_SOURCE.CHROMEBOOKS_LAPTOPS' | translate }}</div>
	</div>
	<div class="upload-modal__option" (click)="fileInput.click()">
		<div class="upload-modal__option-title">{{ 'SELECT_UPLOAD_SOURCE.PHONE_CAMERA' | translate }}</div>
		<div class="upload-modal__option-subtitle">{{ 'SELECT_UPLOAD_SOURCE.PHONES_TABLETS_OR' | translate }} <a class="ul">{{ 'SELECT_UPLOAD_SOURCE.UPLOAD_A_FILE' | translate }}</a></div>
	</div>
</div>

<div class="modal-footer upload-modal__footer justify-content-end">
	<button type="button" class="btn btn-default" (click)="cancel()" data-dismiss="modal">{{ 'SELECT_UPLOAD_SOURCE.CANCEL' | translate }}</button>
</div>

<input class="d-none" type="file" (change)="uploadFile($event)" #fileInput [accept]="acceptedExtensions">
